import { _ as _defineProperty } from '../defineProperty-Y-S4SptN.js';
import { _ as _objectWithoutProperties } from '../objectWithoutProperties-w3bsUgPa.js';
import { useMemo } from 'react';
import classNames from 'classnames';
import { S as SvgIcon } from '../SvgIcon-zgkXaGhD.js';
import { getBreakPointValues } from '../breakpoints/index.js';
import createUseStyles from '../create/index.js';
import { mediaQuery } from '../helpers/index.js';
import { BreakPoints } from '../enums/index.js';
import { j as jsxRuntimeExports } from '../jsx-runtime-KJzvSKZ_.js';

var useStyles = createUseStyles({
  root: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
    display: 'inline-block',
    verticalAlign: 'top',
    width: function width(props) {
      var _props$sizes;
      return (_props$sizes = props.sizes) === null || _props$sizes === void 0 ? void 0 : _props$sizes.xl;
    },
    height: function height(props) {
      var _props$sizes2;
      return (_props$sizes2 = props.sizes) === null || _props$sizes2 === void 0 ? void 0 : _props$sizes2.xl;
    },
    borderRadius: '50%',
    padding: 3,
    backgroundColor: 'var(--premium-base)'
  }, mediaQuery(BreakPoints.ExtraLarge), {
    width: function width(props) {
      var _props$sizes3;
      return (_props$sizes3 = props.sizes) === null || _props$sizes3 === void 0 ? void 0 : _props$sizes3.lg;
    },
    height: function height(props) {
      var _props$sizes4;
      return (_props$sizes4 = props.sizes) === null || _props$sizes4 === void 0 ? void 0 : _props$sizes4.lg;
    }
  }), mediaQuery(BreakPoints.Large), {
    width: function width(props) {
      var _props$sizes5;
      return (_props$sizes5 = props.sizes) === null || _props$sizes5 === void 0 ? void 0 : _props$sizes5.md;
    },
    height: function height(props) {
      var _props$sizes6;
      return (_props$sizes6 = props.sizes) === null || _props$sizes6 === void 0 ? void 0 : _props$sizes6.md;
    }
  }), mediaQuery(BreakPoints.Medium), {
    width: function width(props) {
      var _props$sizes7;
      return (_props$sizes7 = props.sizes) === null || _props$sizes7 === void 0 ? void 0 : _props$sizes7.sm;
    },
    height: function height(props) {
      var _props$sizes8;
      return (_props$sizes8 = props.sizes) === null || _props$sizes8 === void 0 ? void 0 : _props$sizes8.sm;
    }
  }), '& > svg', {
    '& > path': {
      fill: 'var(--absolute-white-base)'
    }
  })
}, {
  name: 'gold-badge'
});

var _excluded = ["size", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function GoldBadge(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var sizes = useMemo(function () {
    return getBreakPointValues(size);
  }, [size]);
  var classes = useStyles({
    sizes: sizes
  });
  return /*#__PURE__*/jsxRuntimeExports.jsx(SvgIcon, _objectSpread({
    className: classNames(classes.root, className),
    name: "icon__crown__filled"
  }, props));
}

export { GoldBadge as default };
//# sourceMappingURL=index.js.map
